// ponytail: JSONP is required because Mailchimp's list-manage.com endpoint has no CORS support
(function () {
  function jsonp(url, callback) {
    var script = document.createElement('script');
    var cbName = 'mc_cb_' + Date.now() + '_' + Math.floor(Math.random() * 1e6);

    window[cbName] = function (data) {
      delete window[cbName];
      script.remove();
      callback(data);
    };

    script.src = url + (url.indexOf('?') === -1 ? '?' : '&') + 'c=' + cbName;
    script.onerror = function () {
      delete window[cbName];
      script.remove();
      callback({ result: 'error', msg: 'Network error, please try again.' });
    };

    document.body.appendChild(script);
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.classList.contains('mailchimp-form')) return;

    event.preventDefault();

    var fields = form.querySelector('.mailchimp-form__fields');
    var successEl = form.querySelector('.mailchimp-form__success');
    var errorEl = form.querySelector('.mailchimp-form__error');
    var errorTextEl = form.querySelector('.mailchimp-form__error-text') || errorEl;
    var button = form.querySelector('[type="submit"]');

    if (errorEl) errorEl.classList.add('hidden');
    if (button) button.disabled = true;

    var action = form.action.replace('/post?', '/post-json?');
    var params = new URLSearchParams(new FormData(form)).toString();

    jsonp(action + '&' + params, function (data) {
      if (button) button.disabled = false;

      if (data.result === 'success') {
        if (fields) fields.classList.add('hidden');
        if (successEl) successEl.classList.remove('hidden');
        form.reset();
        form.dispatchEvent(new CustomEvent('mailchimp:success', { bubbles: true }));
      } else if (errorTextEl) {
        errorTextEl.textContent = (data.msg || 'Something went wrong.').replace(/^\d+\s*-\s*/, '');
        if (errorEl) errorEl.classList.remove('hidden');
      }
    });
  });
})();
